var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"250px","width":"400px","margin":"auto"}},[_c('object',{attrs:{"data":"assets/img/nodataavailable-image.svg"}})])
}]

export { render, staticRenderFns }